import React from "react";

// FollowupChips renders `response.suggested_followups` (SP3-T5) as clickable
// chips under an answer; picking one resubmits the chip text as a new ask.
// Chip styling matches ClarifyCard's chips for visual consistency.
export default function FollowupChips({ items = [], onPick = () => {} }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {items.map((text) => (
        <button
          key={text}
          type="button"
          onClick={() => onPick(text)}
          className="text-sm px-3 py-1 rounded-lg border border-border text-text-2 hover:bg-surface-2"
        >
          {text}
        </button>
      ))}
    </div>
  );
}
